import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import { Helmet } from 'react-helmet';

export default function Privacy() {
  return (
    <>
    <Helmet>
  <title>Privacy Policy - Namami India Support Services</title>
  <meta
    name="description"
    content="Read Namami India's Privacy Policy to understand how we collect, use, and protect your personal information in compliance with Indian data protection laws."
  />
  <meta
    name="keywords"
    content="Namami India, privacy policy, data protection, confidentiality, information security"
  />
  <meta property="og:title" content="Privacy Policy - Namami India" />
  <meta
    property="og:description"
    content="Our privacy policy ensures transparency in how we handle and protect user data across all our digital platforms."
  />
  <meta property="og:url" content="https://www.namamiindia.co.in/privacy" />
  <link rel="canonical" href="https://www.namamiindia.co.in/privacy" />
</Helmet>

    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" fontWeight={700} gutterBottom color="primary">
        Privacy Policy
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
        Last updated: {new Date().getFullYear()}
      </Typography>

      <Paper sx={{ p: 4, background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              1. Information We Collect
            </Typography>
            <Typography variant="body1" paragraph>
              At Namami India Support Services, we collect information that you provide directly to us, 
              including name, email address, phone number, and any other information you choose to provide 
              when contacting us for our services.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              2. How We Use Your Information
            </Typography>
            <Typography variant="body1" paragraph>
              We use the information we collect to:
            </Typography>
            <Box component="ul" sx={{ pl: 3 }}>
              <Typography component="li" variant="body1" paragraph>
                Provide, maintain, and improve our services
              </Typography>
              <Typography component="li" variant="body1" paragraph>
                Respond to your comments, questions, and requests
              </Typography>
              <Typography component="li" variant="body1" paragraph>
                Send you technical notices and support messages
              </Typography>
              <Typography component="li" variant="body1">
                Monitor and analyze trends and usage
              </Typography>
            </Box>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              3. Information Sharing
            </Typography>
            <Typography variant="body1" paragraph>
              We do not sell, trade, or otherwise transfer your personally identifiable information 
              to outside parties unless we provide users with advance notice.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              4. Data Security
            </Typography>
            <Typography variant="body1" paragraph>
              We implement appropriate technical and organizational security measures designed to 
              protect the security of any personal information we process.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              5. Contact Us
            </Typography>
            <Typography variant="body1">
              If you have any questions about this Privacy Policy, please contact us at:
              <br />
              <strong>Email:</strong> info@namamiindia.co.in
              <br />
              <strong>Phone:</strong> +91 96927 83839
            </Typography>
          </section>
        </Box>
      </Paper>
    </Container>
    </>
  );
}